import { render } from "./ModalBan.vue?vue&type=template&id=45c94f0e&scoped=true"
import script from "./ModalBan.vue?vue&type=script&lang=js"
export * from "./ModalBan.vue?vue&type=script&lang=js"

import "./ModalBan.vue?vue&type=style&index=0&id=45c94f0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c94f0e"]])

export default __exports__